import { reatomAsync, withDataAtom } from "@reatom/async";

import { APIKnowledge, KNOWLEDGE_TREE_FIELDS } from "./knowledge.constants";

export const knowledgeTree = reatomAsync(async () => {
  const query = KNOWLEDGE_TREE_FIELDS.join(",");
  const res = await fetch(
    `${APIKnowledge}/items/rootDocsPoizon?fields=${query}&sort=order`,
  );

  const json = await res.json();
  return {
    tree: json.data,
  };
}, "knowledgeTree").pipe(withDataAtom(null));
